import React from "react";
import { InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { ediphiPalette } from "../../styles/colors";
import { InputField } from "./InputField.styled";

interface SearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

/**
 * The app's search input. Controlled, because callers hold the query for their own filtering rather
 * than reading it back out of the field.
 */
const SearchField: React.FC<SearchFieldProps> = ({ value, onChange, placeholder = "Search" }) => (
  <InputField
    fullWidth
    sx={{
      backgroundColor: ediphiPalette.surface,
    }}
    size="small"
    variant="outlined"
    placeholder={placeholder}
    value={value}
    onChange={(event) => onChange(event.target.value)}
    slotProps={{
      input: {
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" sx={{ color: ediphiPalette.greyText }} />
          </InputAdornment>
        ),
      },
    }}
  />
);

export default SearchField;
